import { Empty, Icon } from 'ui';
import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { EntityList } from 'features/channels/components/entity-list';
import { useCommunitiesInfiniteQuery } from 'features/communities';

type P = {
  getPathToCommunityDetail: (id: string) => string;
  memberId: string;
  search?: string;
};

const MemberCommunitiesList = ({ getPathToCommunityDetail, memberId, search: propertySearch }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const {
    data: allCommunitiesData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useCommunitiesInfiniteQuery({
    filter: { scope: 'joined', search, userId: memberId },
    pagination: { pageSize: 12 },
  });

  const allCommunities = allCommunitiesData?.pages.flat().flatMap((communitiesPaginated) => communitiesPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no communities to display here',
            title: 'No communities',
          }}
          image={<Icon icon="classify-2-line" />}
        />
      }
      entities={allCommunities?.map((community) => ({
        data: community,
        type: 'Community',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToCommunityDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll || isDebouncing}
    />
  );
};

export default MemberCommunitiesList;
